import ReactDOM from 'react-dom/client'
import { BrowserRouter, Link, NavLink } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Provider } from 'react-redux'

import { store } from './app/store'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import '../src/style.scss'
import { setInnerTabLinkProvider } from '@netapp/bxp-design-system-react'
require('@netapp/bxp-design-system-react/dist/index.css')
require('@netapp/bxp-style/css/reset.css')


const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
setInnerTabLinkProvider({ Link, NavLink, reactRouterVersion: 6 })
root.render(
  <>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </Provider>
  </>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
